import {NgIf} from '@angular/common';
import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-getting-started',
	templateUrl:'./GettingStartedPage.html',
	styles: [],
	styleUrls:['./GettingStartedPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		NgIf,
		WaDividerDirective,
		WaTextDirective,
		WaTagDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class GettingStartedPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_3 = `\`\`\`java
@NgApp(value = "my-app", bootComponent = MyHomePage.class)
public class MyApplication extends NGApplication<MyApplication> {
    public MyApplication() {
        getOptions().setTitle("My App");
    }
}
\`\`\``;
	mdContent_4 = `\`\`\`xml
<plugin>
    <groupId>com.jwebmp.plugins</groupId>
    <artifactId>angular-maven-plugin</artifactId>
    <version>\${jwebmp.version}</version>
    <executions>
        <execution>
            <id>build-angular</id>
            <phase>install</phase>
            <goals>
                <goal>build</goal>
            </goals>
        </execution>
    </executions>
</plugin>
\`\`\``;
	mdContent_5 = `\`\`\`groovy
plugins {
    id("com.jwebmp.angular") version jwebmpVersion
}

jwebmpAngular {
    // runs during the build task
}
\`\`\``;
	mdContent_6 = `\`\`\`java
public class Boot extends Page<Boot> {
    public Boot() {
        getOptions().setTitle("My App");
        add("Hello World");
    }

    public static void main(String[] args) {
        System.setProperty("HTTP_ENABLED", "true");
        IGuiceContext.instance().inject();
    }
}
\`\`\``;
	mdContent_7 = `\`\`\`java
@NgComponent("my-home")
@NgRoutable(path = "")
public class MyHomePage extends DivSimple<MyHomePage>
        implements INgComponent<MyHomePage> {

    public MyHomePage() {
        var card = new WaCard<>();
        card.add("Welcome to JWebMP!");
        add(card);

        var button = new WaButton<>("Click Me", Variant.Brand);
        add(button);
    }
}
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
